export const ZAMPLIA_SURVEYS_VENDOR__ID = "1220228VENDOR1662983969646";
export const ZAMPLIA_SURVEYS_VENDOR_ID = "313";
export const IP_REGISTRY_KEY = "Bn4uzStMTc843jYFASBb2IJI2gL42auGMG04j3Ec1kUJnsCvPA";
export const IP_URL = "https://ipapi.co/json";